import fitvids from 'fitvids';
import $script from 'scriptjs';

const api = 'https://www.youtube.com/iframe_api';
let apiLoadedCallbacks = [];
let apiLoaded = false;

window.onYouTubeIframeAPIReady = () => {
  apiLoadedCallbacks.forEach(apiLoadedCallback => apiLoadedCallback());
  apiLoadedCallbacks = [];
  apiLoaded = true;
};

export default class Youtube {
  constructor(el) {
    const url = el.getAttribute('data-video-url');
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
    this.el = el;
    this.id = url.match(regex)[1] || null;

    this.onApiLoaded = this._onApiLoaded.bind(this);

    this.isReady = false;
    this.onReady = this._onReady.bind(this);
    this.onReadyCallback = null;

    this.onStateChange = this._onStateChange.bind(this);
    this.onPlayCallback = null;

    if (apiLoaded) {
      this._onApiLoaded();
    } else {
      apiLoadedCallbacks.push(this.onApiLoaded);
      $script(api);
    }
  }

  play() {
    return new Promise((resolve) => {
      this.onPlayCallback = resolve;

      if (this.isReady) {
        this.player.playVideo();
      } else {
        this.onReadyCallback = this.player.playVideo;
      }
    });
  }

  unload() {
    this.player.destroy();
  }

  _onApiLoaded() {
    this.player = new YT.Player(this.el, {
      videoId: this.id,
      playerVars: {
        modestbranding: true,
        showinfo: false,
        controls: false,
      },
      events: {
        onReady: this.onReady,
        onStateChange: this.onStateChange,
      },
    });

    fitvids();
  }

  _onReady() {
    this.isReady = true;

    if (this.onReadyCallback) {
      this.onReadyCallback();
    }
  }

  _onStateChange(event) {
    const state = event.data;

    if (
      this.onPlayCallback
      && state === YT.PlayerState.PLAYING
    ) {
      this.onPlayCallback();
      this.onPlayCallback = null;
    }
  }
}
